import React from 'react'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import styled from 'particles/themes/styled'
import Text from 'particles/Text'
import InfoTooltip from 'components/InfoTooltip'

const InfoTooltipCell: React.FC<GridRenderCellParams> = params => {
    return (
        <Container width={params.colDef.computedWidth}>
            <Text scale="bodyM500" className="header-text">
                {params.value.value}
            </Text>
            {params.value.info && (
                <InfoTooltip size="16px" marginLeft="8px" label={params.value.info} iconColor="primary" />
            )}
        </Container>
    )
}

const Container = styled.div<{ width?: number }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: ${({ width }) => width || '0'}px;

    .header-text {
        white-space: normal;
        word-wrap: break-word;
        line-height: 1.2em;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`

export default InfoTooltipCell
